<template>
  <div class="debug-page">
    <div class="debug-card">
      <h2>💳 支付参数调试</h2>
      
      <div class="section">
        <h3>请求参数</h3>
        <div class="params-box">
          <pre>{{ JSON.stringify(requestParams, null, 2) }}</pre>
        </div>
      </div>

      <div class="section" v-if="apiResponse">
        <h3>API 响应</h3>
        <div class="params-box" :class="{ error: apiResponse.code !== 0 }">
          <pre>{{ JSON.stringify(apiResponse, null, 2) }}</pre>
        </div>
      </div>

      <div class="section" v-if="redirectUrl">
        <h3>跳转URL</h3>
        <div class="url-box">
          <a :href="redirectUrl" target="_blank">{{ redirectUrl }}</a>
        </div>
      </div>

      <div class="actions">
        <button class="btn-primary" @click="proceedToPayment" :disabled="!redirectUrl">
          继续跳转支付
        </button>
        <button class="btn-secondary" @click="goBack">
          返回
        </button>
      </div>

      <div class="loading" v-if="loading">
        <van-loading size="24px" color="#667eea">加载中...</van-loading>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaymentDebug',
  data() {
    return {
      loading: true,
      requestParams: {},
      apiResponse: null,
      redirectUrl: null
    }
  },
  created() {
    // 从路由获取参数
    this.requestParams = {
      method: this.$route.query.method || 'alipay',
      amount: this.$route.query.amount || 0,
      type: this.$route.query.type || 'single',
      videoId: this.$route.query.videoId || null,

    };
  },
  mounted() {
    this.callPaymentAPI();
  },
  methods: {
    async callPaymentAPI() {
      try {
        this.loading = true;

        // 准备请求体
        const userStr = localStorage.getItem('user');
        let requestBody = {
          type: this.requestParams.type,
          amount: this.requestParams.amount,
          videoId: this.requestParams.videoId,
          paymentMethod: this.requestParams.method === 'wechat' ? 'wechat' : 'alipay'
        };

        if (userStr) {
          const user = JSON.parse(userStr);
          requestBody.username = user.username;
        } else {
          let deviceId = localStorage.getItem('deviceId');
          if (!deviceId) {
            deviceId = 'device_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
            localStorage.setItem('deviceId', deviceId);
          }
          requestBody.deviceId = deviceId;
        }

        // 更新显示的请求参数
        this.requestParams = {
          ...this.requestParams,
          ...requestBody
        };

        // 调用API
        const response = await this.$http.post('/direct/create', requestBody);
        this.apiResponse = response.data;

        if (response.data.code === 0 && response.data.data.requestURL) {
          this.redirectUrl = response.data.data.requestURL;
        }

      } catch (e) {
        console.error('API Error:', e);
        this.apiResponse = {
          code: -1,
          message: e.message,
          error: e.response?.data || 'Network Error'
        };
      } finally {
        this.loading = false;
      }
    },
    proceedToPayment() {
      if (this.redirectUrl) {
        window.location.href = this.redirectUrl;
      }
    },
    goBack() {
      this.$router.back();
    }
  }
}
</script>

<style scoped>
.debug-page {
  background: linear-gradient(180deg, #1a1a2e 0%, #0f0f23 100%);
  min-height: 100vh;
  padding: 20px;
  color: #fff;
}

.debug-card {
  background: rgba(255,255,255,0.05);
  border-radius: 12px;
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
}

h2 {
  text-align: center;
  margin-bottom: 20px;
  color: #667eea;
}

h3 {
  font-size: 14px;
  color: #888;
  margin-bottom: 10px;
  border-bottom: 1px solid #333;
  padding-bottom: 5px;
}

.section {
  margin-bottom: 20px;
}

.params-box {
  background: #1a1a1a;
  border-radius: 8px;
  padding: 15px;
  overflow-x: auto;
}

.params-box.error {
  border: 1px solid #ff4444;
}

.params-box pre {
  margin: 0;
  font-size: 12px;
  color: #4CAF50;
  white-space: pre-wrap;
  word-break: break-all;
}

.url-box {
  background: #1a1a1a;
  border-radius: 8px;
  padding: 15px;
  word-break: break-all;
}

.url-box a {
  color: #667eea;
  font-size: 12px;
}

.actions {
  display: flex;
  gap: 10px;
  margin-top: 20px;
}

.btn-primary {
  flex: 1;
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  border: none;
  padding: 12px;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
}

.btn-primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-secondary {
  flex: 1;
  background: #333;
  color: white;
  border: 1px solid #555;
  padding: 12px;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
}

.loading {
  text-align: center;
  padding: 20px;
}
</style>
